module.exports = __webpack_public_path__ + "static/media/ruoppaukset-8.db967e03.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/ruoppaukset-8.jpg
// module id = 43
// module chunks = 0